import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Services = () => {
  const serviceCategories = [
    {
      title: "Patient Growth & Visibility",
      icon: (
        <svg className="w-10 h-10 sm:w-12 sm:h-12 text-[#19354a]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
        </svg>
      ),
      path: "/services/growth-visibility",
      services: [
        "SEO for Doctors",
        "Local SEO (Clinic Area Targeting)",
        "Google My Business (GMB) Management",
        "Multi-Location Clinic SEO",
        "Medical Directory Listings",
        "Online Reputation Management"
      ],
      subCategory: {
        title: "Advanced Healthcare SEO",
        services: [
          "Review & Rating Growth",
          "Patient Search Optimization"
        ]
      }
    },
    {
      title: "Ads & Patient Acquisition",
      icon: (
        <svg className="w-10 h-10 sm:w-12 sm:h-12 text-[#19354a]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46" />
        </svg>
      ),
      path: "/services/marketing-client-acquisition",
      services: [
        "Google Ads for Doctors",
        "Meta Ads (Facebook & Instagram)",
        "LinkedIn Ads (Hospitals & Groups)",
        "Patient Lead Generation",
        "Funnel & Retargeting Setup",
        "Ad Monitoring & Optimization"
      ],
      subCategory: {
        title: "Healthcare Analytics",
        services: [
          "Conversion Tracking",
          "ROI Performance Reports"
        ]
      }
    },
    {
      title: "Social Media & Branding",
      icon: (
        <svg className="w-10 h-10 sm:w-12 sm:h-12 text-[#19354a]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9.53 16.122a3 3 0 00-5.78 1.128 2.25 2.25 0 01-2.4 2.245 4.5 4.5 0 008.4-2.245c0-.399-.078-.78-.22-1.128zm0 0a15.998 15.998 0 003.388-1.62m-5.043-.025a15.994 15.994 0 011.622-3.395m3.42 3.42a15.995 15.995 0 004.764-4.648l3.876-5.814a1.151 1.151 0 00-1.597-1.597L14.146 6.32a15.996 15.996 0 00-4.649 4.763m3.42 3.42a6.776 6.776 0 00-3.42-3.42" />
        </svg>
      ),
      path: "/services/social-media-branding",
      services: [
        "Social Media Management",
        "Content Planning & Posting",
        "Instagram, Facebook & LinkedIn",
        "Comment & DM Management",
        "Influencer & Medical Outreach",
        "Doctor Brand Building"
      ],
      subCategory: {
        title: "Patient Engagement",
        services: [
          "Health Awareness Campaigns",
          "Patient Education Content"
        ]
      }
    },
    {
      title: "Lead Management & Virtual Assistants",
      icon: (
        <svg className="w-10 h-10 sm:w-12 sm:h-12 text-[#19354a]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611l-.417.07a9.058 9.058 0 01-3.09 0l-.417-.07c-1.717-.293-2.3-2.379-1.067-3.611L16.5 15.3M5 14.5l-1.402 1.402c-1.232 1.232-.65 3.318 1.067 3.611l.417.07c1.03.177 2.073.177 3.102 0l.417-.07c1.717-.293 2.3-2.379 1.067-3.611L8.5 14.5" />
        </svg>
      ),
      path: "/services/meta-virtual-assistant",
      services: [
        "Lead Management System",
        "CRM Setup & Automation",
        "Appointment Booking Support",
        "Patient Follow-Ups",
        "Meta Ads Virtual Assistant",
        "Customer Support Assistance"
      ],
      subCategory: {
        title: "Healthcare CRM",
        services: [
          "Patient Data Management",
          "Automated Workflows"
        ]
      }
    },
    {
      title: "Patient Communication & Analytics",
      icon: (
        <svg className="w-10 h-10 sm:w-12 sm:h-12 text-[#19354a]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      path: "/services/patient-communication-analytics",
      services: [
        "Email Marketing for Clinics",
        "WhatsApp Patient Campaigns",
        "Automated Appointment Reminders",
        "Performance Reports",
        "Conversion & ROI Analytics",
        "Patient Segmentation"
      ],
      subCategory: {
        title: "Healthcare Metrics",
        services: [
          "Patient Engagement Tracking",
          "Practice Growth Analytics"
        ]
      }
    },
    {
      title: "Websites, Apps & Technology",
      icon: (
        <svg className="w-10 h-10 sm:w-12 sm:h-12 text-[#19354a]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" />
        </svg>
      ),
      path: "/services/digital-platforms-experience",
      services: [
        "Domain Purchase & Management",
        "Doctor & Clinic Website Development",
        "Website Redesign & Revamp",
        "Conversion-Focused Design",
        "Website Speed Optimization",
        "App Development for Clinics"
      ],
      subCategory: {
        title: "Medical Platforms",
        services: [
          "Patient Portal Development",
          "HIPAA-Compliant Security"
        ]
      }
    },
    {
      title: "Creative, Media & Content",
      icon: (
        <svg className="w-10 h-10 sm:w-12 sm:h-12 text-[#19354a]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      ),
      path: "/services/creative-media-branding",
      services: [
        "Brand Identity & Logo Design",
        "Social Media Creatives",
        "Ad Creatives & Banners",
        "Video Editing",
        "Motion Graphics",
        "Pitch Decks & Brochures"
      ],
      subCategory: {
        title: "Medical Content",
        services: [
          "Patient Education Materials",
          "Medical Explainer Videos"
        ]
      }
    },
    {
      title: "Systems, Compliance & Consulting",
      icon: (
        <svg className="w-10 h-10 sm:w-12 sm:h-12 text-[#19354a]" fill="none" stroke="currentColor" strokeWidth={1.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
        </svg>
      ),
      path: "/services/systems-automation-consulting",
      services: [
        "Analytics Dashboards",
        "CRM & Marketing Automation",
        "Backup & Data Protection",
        "Compliance & Website Security",
        "Clinic Growth Consulting",
        "Digital Strategy Consulting"
      ],
      subCategory: {
        title: "Healthcare Compliance",
        services: [
          "HIPAA Compliance",
          "Data Security Monitoring"
        ]
      }
    }
  ];

  return (
    <div className="font-['Raleway',sans-serif] bg-white text-gray-900 overflow-x-hidden pt-[90px]">
      
      <Navbar />

      {/*  HERO SECTION  */}
      <section className="relative min-h-[300px] flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://images.unsplash.com/photo-1552664730-d307ca884978?w=1920&q=80')`,
          }}
        />
        <div className="absolute inset-0 bg-[#19354a]/90" />
        
        <div className="relative z-10 text-center px-4 sm:px-6">
          <motion.h1 
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 sm:mb-8"
          >
            Our Healthcare Services
          </motion.h1>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center justify-center gap-2 sm:gap-4 flex-wrap"
          >
            <Link 
              to="/" 
              className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold hover:bg-[#2a8db8] transition-all text-sm sm:text-base"
            >
              Home
            </Link>
            <span className="text-white text-xl sm:text-2xl">|</span>
            <span className="px-6 sm:px-8 py-2.5 sm:py-3 bg-[#39a5d3] text-white rounded-full font-semibold text-sm sm:text-base">
              Services
            </span>
          </motion.div>
        </div>
      </section>

      {/*  SERVICES INTRO  */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-4 sm:mb-6"
          >
            Our Healthcare <span className="text-[#19354a]">Services</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed"
          >
            We offer comprehensive healthcare Growth Ecosystem and technology solutions tailored to help your medical practice grow. From patient acquisition to practice management, we've got you covered.
          </motion.p>
        </div>
      </section>

      {/*  SERVICES GRID  */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            
            {serviceCategories.map((category, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-[#f0f7fb] rounded-2xl p-6 sm:p-8 border-2 border-transparent hover:border-[#39a5d3] hover:shadow-xl transition-all duration-300"
              >
                {/* Icon */}
                <div className="mb-4 sm:mb-6">
                  <div className="flex gap-1">
                    <div className="w-6 sm:w-8 h-2 bg-[#19354a] rounded-full"></div>
                    <div className="w-6 sm:w-8 h-2 bg-[#39a5d3] rounded-full"></div>
                  </div>
                  <div className="flex gap-1 mt-1">
                    <div className="w-6 sm:w-8 h-2 bg-[#39a5d3] rounded-full"></div>
                    <div className="w-6 sm:w-8 h-2 bg-[#19354a] rounded-full"></div>
                  </div>
                  <div className="flex gap-1 mt-1">
                    <div className="w-6 sm:w-8 h-2 bg-[#19354a] rounded-full"></div>
                    <div className="w-6 sm:w-8 h-2 bg-[#39a5d3] rounded-full"></div>
                  </div>
                </div>

                {/* Title */}
                <Link to={category.path}>
                  <h3 className="text-lg sm:text-xl font-bold text-[#19354a] mb-4 sm:mb-5 hover:text-[#39a5d3] transition-colors">
                    {category.title}
                  </h3>
                </Link>

                {/* Services List */}
                <ul className="space-y-2 sm:space-y-3 mb-4 sm:mb-6">
                  {category.services.map((service, idx) => (
                    <li key={idx} className="flex items-start gap-2">
                      <span className="text-[#39a5d3] font-bold mt-0.5 text-sm sm:text-base">»</span>
                      <span className="text-gray-700 text-sm sm:text-base">{service}</span>
                    </li>
                  ))}
                </ul>

                {/* Sub Category */}
                {category.subCategory && (
                  <>
                    <h4 className="text-base sm:text-lg font-bold text-[#19354a] mb-2 sm:mb-3">
                      {category.subCategory.title}
                    </h4>
                    <ul className="space-y-2 sm:space-y-3">
                      {category.subCategory.services.map((service, idx) => (
                        <li key={idx} className="flex items-start gap-2">
                          <span className="text-[#39a5d3] font-bold mt-0.5 text-sm sm:text-base">»</span>
                          <span className="text-gray-700 text-sm sm:text-base">{service}</span>
                        </li>
                      ))}
                    </ul>
                  </>
                )}

                {/* View More Link */}
                <Link 
                  to={category.path}
                  className="inline-flex items-center gap-2 mt-4 sm:mt-6 text-[#19354a] font-semibold hover:text-[#39a5d3] transition-colors text-sm sm:text-base"
                >
                  Learn More
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                  </svg>
                </Link>
              </motion.div>
            ))}

          </div>
        </div>
      </section>

      {/*  WHY CHOOSE US SECTION  */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8 sm:mb-12"
          >
            <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
              Why Choose <span className="text-[#19354a]">Docmize</span>?
            </h2>
            <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto px-4">
              We deliver results-driven healthcare marketing solutions that help medical practices thrive in the digital landscape.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
            
            {/* Feature 1 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white rounded-2xl p-5 sm:p-6 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <svg className="w-7 h-7 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Proven Patient Growth</h3>
              <p className="text-xs sm:text-sm text-gray-600">
                Track record of delivering measurable patient acquisition for medical practices.
              </p>
            </motion.div>

            {/* Feature 2 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white rounded-2xl p-5 sm:p-6 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <svg className="w-7 h-7 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                </svg>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Healthcare Experts</h3>
              <p className="text-xs sm:text-sm text-gray-600">
                Skilled healthcare marketers dedicated to your medical practice success.
              </p>
            </motion.div>

            {/* Feature 3 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-white rounded-2xl p-5 sm:p-6 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <svg className="w-7 h-7 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                </svg>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">HIPAA Compliance</h3>
              <p className="text-xs sm:text-sm text-gray-600">
                All marketing strategies follow strict healthcare privacy regulations.
              </p>
            </motion.div>

            {/* Feature 4 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="bg-white rounded-2xl p-5 sm:p-6 border-2 border-[#19354a] text-center hover:shadow-xl transition-all"
            >
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#19354a] rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                <svg className="w-7 h-7 sm:w-8 sm:h-8 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
                </svg>
              </div>
              <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-2">Fast Patient Results</h3>
              <p className="text-xs sm:text-sm text-gray-600">
                Quick campaign launches that bring patients to your practice fast.
              </p>
            </motion.div>

          </div>
        </div>
      </section>

      {/*  CTA SECTION  */}
      <section className="py-12 sm:py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <motion.h2 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 sm:mb-6"
          >
            Ready to Grow Your Medical Practice?
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-sm sm:text-base lg:text-lg text-gray-600 mb-6 sm:mb-8"
          >
            Let's discuss how our healthcare marketing services can help you attract more patients and achieve your practice goals.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center"
          >
            <Link 
              to="/contact" 
              className="px-6 sm:px-8 py-3 sm:py-4 bg-[#19354a] text-white rounded-lg font-semibold hover:bg-[#0f2133] transition-all text-sm sm:text-base"
            >
              Get a Free Consultation
            </Link>
            <a 
              href="tel:+918920845297" 
              className="px-6 sm:px-8 py-3 sm:py-4 border-2 border-[#19354a] text-[#19354a] rounded-lg font-semibold hover:bg-[#19354a] hover:text-white transition-all text-sm sm:text-base"
            >
              Call Us Now
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;